// tslint:disable:variable-name
import { get } from 'lodash'
import { Record } from './record-data-store'

export const id = (record: Record) => get(record, 'id')

export const recordIdentifier = (record: Record) => _recordIdentifier(record) || get(record, 'recolementIdentificationSchema.numberIdentifier');
export const linkedItemId = (record: Record) => _linkedItemId(record) || get(record, 'recolementLinkSchema.linkedItem.linkableItem');
export const currentState = (record: Record, locale: string) => _currentState(record, locale) || get(record, `workflowSchema.currentState.name`)

////////////////////////////////
//// Search result specific ////
////////////////////////////////
export const _recordIdentifier = (record: Record) => get(record, 'recolementIdentificationSchema.numberIdentifier.value');
export const _linkedItemId = (record: Record) => get(record, 'recolementLinkSchema.linkedItem.ref');
export const _currentState = (record: Record, locale: string) => get(record, `workflowSchema.currentState.${locale}`)